import React from 'react';
import { array, func, number, object } from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { numberFormat } from '@fiverr-private/localization';
import Collect from '@fiverr-private/collect';
import { getContext } from '@fiverr-private/fiverr_context';
import { PAGE_NAME } from '../../../utils/events';
import { updateCollections } from '../../../actions/collections';

import './style.scss';

const CollectWrapper = (
    { collections, gigCollectedCount, updateCollections },
    { general }
) => {
    const { userId, isTouch } = getContext();
    const { gigId } = general;

    const resource = {
        id: gigId,
        type: Collect.RESOURCE_TYPES.GIG
    };

    const sourceInfo = {
        name: PAGE_NAME,
        userId,
        isTouch
    };

    // The additional wrapper class is due to an issue with how webpack bundles css rules.
    // Should be removed when issue is resolved
    const collectBodyClass = 'gig-page-nav-collect';

    const formattedGigCollectedCount = numberFormat(gigCollectedCount, {
        fallbackValue: gigCollectedCount
    });

    return (
        <div className="collect-wrapper">
            <Collect collections={collections}
                resource={resource}
                onUpdateCollections={updateCollections}
                menuPosition={Collect.MENU_POSITIONS.BOTTOM_LEFT}
                allowMenuOverflow
                sourceInfo={sourceInfo}
                className="nav-collect"
                tooltipClassName={classNames(collectBodyClass, 'tooltip')}/>
            {gigCollectedCount > 0 && <span className="collect-count">{formattedGigCollectedCount}</span>}
        </div>
    );
};

CollectWrapper.propTypes = {
    collections: array,
    gigCollectedCount: number,
    updateCollections: func
};

CollectWrapper.contextTypes = {
    general: object
};

const mapStateToProps = ({ collections }) => ({
    collections
});

export { CollectWrapper };
export default connect(mapStateToProps, { updateCollections })(CollectWrapper);
